/**
 * The search box. Typed words search titles, artists and albums; `field:value`
 * terms (genre:amapiano, bpm:110..120, key:8A) become chips the engine
 * compiles, and a term it cannot read is shown as such rather than ignored.
 */

import { useApp } from "../core/app";
import { Icon } from "./Icons";
import { MOD } from "./menus";

export function SearchField({ placeholder = "Search songs, artists, albums…", compact = false }: { placeholder?: string; compact?: boolean }) {
  const app = useApp();
  const q = app.typedQuery;
  const bad = q.errors.length > 0;
  return (
    <label className={`nv-search ${compact ? "compact" : ""} ${bad ? "bad" : ""}`}>
      <Icon name="search" />
      {!compact &&
        q.clauses.slice(0, 3).map((c, i) => (
          <span key={i} className={`nv-token ${c.negated ? "neg" : ""}`} title="A search term Nova understood">
            {c.negated ? "−" : ""}
            {c.field}:{Array.isArray(c.value) ? c.value.join(",") : String(c.value)}
            {c.cmp === "range" && c.value2 !== undefined ? `..${c.value2}` : ""}
          </span>
        ))}
      <input
        data-nv-search
        type="search"
        value={app.input}
        placeholder={placeholder}
        spellCheck={false}
        aria-label="Search the library"
        aria-invalid={bad || undefined}
        title={bad ? q.errors.map((e) => e.message).join("; ") : "Words, or field:value terms like genre:amapiano bpm:110..120 key:8A"}
        onChange={(e) => app.setInput(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Escape") {
            e.stopPropagation();
            if (app.input) app.setInput("");
            else (e.target as HTMLInputElement).blur();
          }
          if (e.key === "Enter" && app.nav.view !== "songs") app.navigate("songs");
        }}
      />
      {!compact && <kbd>{MOD} K</kbd>}
    </label>
  );
}
